// extracted by mini-css-extract-plugin
export default {"btn":"navbutton_btn__WJf6v"};